var React = require('react');

function MarkIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.014 40c-8.537 0-14.997-3.05-18.19-4.948C1.083 34.015 0 32.098 0 30.048V9.952c0-2.05 1.082-3.967 2.825-5.004 5.264-3.13 19.417-9.392 37.105.055C41.824 6.013 43 7.986 43 10.148v19.704c0 2.162-1.176 4.134-3.07 5.145C32.97 38.715 26.554 40 21.014 40zm-.02-36.825c-7.85 0-13.77 2.79-16.698 4.53-.728.432-1.18 1.237-1.18 2.1v20.39c0 .863.452 1.668 1.18 2.1 4.844 2.88 17.882 8.632 34.297-.132.796-.425 1.29-1.256 1.29-2.168v-19.99c0-.912-.494-1.743-1.29-2.168-6.494-3.467-12.46-4.662-17.6-4.662zM10.087 10.9h7.007l4.307 6.506L25.71 10.9h7.007v18.514h-6.69v-9.178L21.4 26.822h-.114l-4.623-6.586v9.178h-6.576V10.9z","id":"a"}));
}

MarkIcon.defaultProps = {"width":"43","height":"40","viewBox":"0 0 43 40"};

module.exports = MarkIcon;

MarkIcon.default = MarkIcon;
